// SignalBars.tsx
import React from 'react';

const SignalBars: React.FC = () => {
  return (
    <div className="flex items-center justify-center space-x-1">
      {Array.from({ length: 20 }).map((_, index) => (
        <div
          key={index}
          className="from-signal-start via-signal-mid to-signal-end animate-signalBar w-1 rounded bg-gradient-to-r"
          style={{ animationDelay: `${index * 0.1}s` }}
        ></div>
      ))}
    </div>
  );
};

export default SignalBars;
